/**
 * The sentence to show for a request the server did not accept: the server's own words first —
 * `message`, then `error` — and the surface's local copy only when the response carries none.
 *
 * ⚠️ **One rule for every surface that shows a refusal** (PR #237 round 4). `apiClient` carries
 * the body's `message` on BOTH failure shapes — an HTTP error and a 200 with `success: false` —
 * so a service's full sentence (for example "…, so the grant was not saved") survives whichever
 * status it answered with. Limits preferred `message` while TeamView read only `error`, so the
 * same 200 `{success:false, error, message}` showed the sentence on one screen and the bare token
 * on the next.
 *
 * Only the CHOICE of sentence lives here. What a surface does about a stale-role refusal
 * (`isStaleRoleRefusal` → `workspaceService.refreshMembership`) stays with the surface, because
 * each captures who issued the write differently and that identity check is the point.
 * Knowledge surfaces map known `details.reason` tokens to merchant copy first
 * (`components/knowledge/refusal.ts`); this is their default for a token they do not know.
 */
export function serverSentence(res: { message?: string; error?: string } | null | undefined, fallback: string): string {
  return res?.message || res?.error || fallback
}
